import { Action, ErrorCodes, OperationType, Position, WindowType } from "puzzle";

export const getOnlineEditorForReopen: Action = [{
  persistent: ['submissionId'],
  type: OperationType.addPersistentData
}, {
  data: {
    template: {
      method: 'post',
      bind: {
        url: "'/submissions/'+{submissionId}+'/reopen/editor/urls'",
        params: '{onlineEditorParams}'
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'onlineEditorUrl',
  type: OperationType.request
}, {
  data: {
    template: {
      bind: {
        responseData: '{onlineEditorUrl}',
      }
    }
  },
  name: 'handleRequestExceptionReopen',
  type: OperationType.action
}, {
  condition: `!_.get({onlineEditorUrl}, "response.data.errors")}`,
  conditionOperations: [{
    moduleName: 'ActionExecutor',
    name: 'prepareEditorOpen',
    args: ['onlineEditorUrl', 'onlineEditorParams'],
    type: OperationType.addOperationData
  }],
  elseOperations: [{
    name: 'filesTabWarningTemplate',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const reopenProcessEditorClose: Action = [{
  condition: '{pingData} && {pingData.processingFinished}',
  conditionOperations: [{
    condition: '{pingData.uploadReportsDto}',
    conditionOperations: [{
      moduleName: 'ReopenDialog',
      name: 'setUploadedTargets',
      args: ['pingData']
    }],
    type: OperationType.conditional
  }, {
    moduleName: 'ActionExecutor',
    name: 'resetPingingInstance'
  }, {
    dispatcherIds: ['reopenTsoPing'],
    type: OperationType.unlink
  }],
  elseOperations: [{
    condition: '!_.get({pingData}, "response.data.errors")}',
    conditionOperations: [{
      actionType: {
        delay: 1000
      },
      data: {
        template: {
          bind: {
            editorSessionId: '{pingParam.editorSessionId}'
          }
        }
      },
      name: 'reopenPing',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  type: OperationType.conditional
}];


export const reopenPing: Action = [{
  data: {
    template: {
      method: 'get',
      bind: {
        url: "'/submissions/' + {submissionId} +'/upload/report/' + {editorSessionId}"
      }
    }
  },
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  mappingName: 'pingData',
  type: OperationType.request,
}, {
  data: {
    template: {
      bind: {
        responseData: '{pingData}',
      }
    }
  },
  name: 'handleRequestExceptionReopen',
  type: OperationType.action
}, {
  name: 'reopenProcessEditorClose',
  type: OperationType.action
}];

export const handleRequestExceptionReopen: Action = [{
  condition: '_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    data: {
      template: {
        endpointPrefix: 'REOPEN_OPEN_'
      }
    },
    type: OperationType.data
  }, {
    data: {
      template: {
        bind: {
          responseData: '{responseData.response}'
        }
      }
    },
    moduleName: 'ErrorHandler',
    name: 'prepareErrorStrings',
    args: ['responseData', 'endpointPrefix'],
    mappingName: 'errorStrings',
    type: OperationType.addOperationData
  }, {
    placeholders: {
      template: {
        bind: {
          close: '{errorStrings.close}',
          text: '{errorStrings.text}',
          title: '{errorStrings.title}',
          warningType: '{errorStrings.warningType}'
        }
      }
    },
    items: [{
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }, {
        dispatcherIds: ['reopenTsoPing'],
        type: OperationType.unlink
      }],
      close: false,
      btnName: 'errorHandler.close',
      btnConfig: {
        fillMode: 'flat',
        pos: Position.end
      }
    }, {
      btnName: 'ESCAPE',
      close: false,
      operations: [{
        windowType: WindowType.warning,
        type: OperationType.closeWindow
      }, {
        dispatcherIds: ['reopenTsoPing'],
        type: OperationType.unlink
      }]
    }],
    className: '{warningType}',
    text: 'errorHandler.text',
    title: 'errorHandler.title',
    type: OperationType.warning
  }, {
    moduleName: 'App',
    type: OperationType.unmaskModule
  }, {
    actionType: {
      dispatcherId: 'mainDispatcher'
    },
    name: 'removeTsoPingDispatcher',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const removeTsoPingDispatcher: Action = [{
  dispatcherIds: ['reopenTsoPing'],
  type: OperationType.stopAll
}, {
  dispatcherIds: ['reopenTsoPing'],
  type: OperationType.unlink
}];